const input = {
    username: 'Username',
    password: 'Password',
    email: 'Email',
    phone_number: 'Phone number',
    confirm_password: 'Confirm password',
    search_region_code: 'Search region code',
    backup_code: 'Backup code',
    code: 'Code',
    label_with_optional: '{{label}} (Optional)',
    email_address: 'Email address',
    email_placeholder: 'Enter your email',
    enter_email: 'Enter email',
};
export default Object.freeze(input);
